module.exports = __webpack_public_path__ + "static/media/mileage_2_10.24a96dcc.png";